export default __webpack_public_path__ + "static/media/walletConnectIcon.488dc369.svg";